export const uploadManager = new Map();
